import React from 'react';
import './Checkbox.scss';

export type CheckboxProps = {
    id: string;
    checked: boolean;
    text: string;
    onChange: () => void;
    disabled?: boolean;
};

const Checkbox = ({
    id,
    checked,
    text,
    onChange,
    disabled
}: CheckboxProps): JSX.Element => {
    return (
        <div className='checkbox-container'>
            <div className='checkbox-div'>
                <input
                    type='checkbox'
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                    name={id}
                />
            </div>
            <label className='checkbox-label' htmlFor={id}>
                {text}
            </label>
        </div>
    );
};

export default Checkbox;
